/**
 * GoogleAnalyticsModel.js
 * Created on 20-apr-2016
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/
export default class GoogleAnalyticsModel {
    constructor(sessionStartTime) {
        this._sessionStartTime = sessionStartTime;
    }

    get sessionStartTime() {
        return this._sessionStartTime;
    }

    set sessionStartTime(value) {
        this._sessionStartTime = value;
    }
}